module.exports = __webpack_public_path__ + "front/img/register-login-kv.d1335d54.png";